import { ArrowLeft } from "lucide-react";
import { useStore } from "zustand";
import { ChannelView } from "@/components/app/channel-view";
import { Button } from "@/components/ui/button";
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@/components/ui/tooltip";
import { coreStore } from "@/lib/stores/core-store";
import { uiStore } from "@/lib/stores/ui-store";

export function ThreadComponent({
	channelId,
	threadId,
}: {
	channelId: string;
	threadId: string;
}) {
	const navigate = useStore(uiStore, (state) => state.navigate);
	const channels = useStore(coreStore, (state) => state.channels);

	const threadChannel = channels.get(threadId);

	const parentChannel = channels.get(channelId);

	if (!(threadChannel && parentChannel)) {
		return (
			<div className="flex h-full items-center justify-center">
				<p className="text-muted-foreground">Thread not found</p>
			</div>
		);
	}

	return (
		<ChannelView.Root channelId={threadId} mainChannelId={channelId}>
			<ChannelView.Header>
				<ChannelView.HeaderGroup className="gap-4">
					<Tooltip>
						<TooltipTrigger asChild>
							<Button
								className="gap-2"
								onClick={() =>
									navigate({ type: "textChannel", params: { channelId } })
								}
								size="sm"
								variant="ghost"
							>
								<ArrowLeft className="h-4 w-4" />
							</Button>
						</TooltipTrigger>
						<TooltipContent>Back to channel</TooltipContent>
					</Tooltip>
					<ChannelView.HeaderTitle>
						Thread on #{parentChannel.name}
					</ChannelView.HeaderTitle>
				</ChannelView.HeaderGroup>
				<ChannelView.HeaderGroup>
					<ChannelView.PeoplePopover />
				</ChannelView.HeaderGroup>
			</ChannelView.Header>
			<ChannelView.MessageList />
			<ChannelView.MessageInput />
		</ChannelView.Root>
	);
}
